import { z } from 'zod';

import { SignupFieldEntrySchema } from '@kit/auth/signup-custom-fields';
import { getSafeRedirectPath } from '@kit/shared/utils';

export type { SignupCustomField } from '@kit/auth/signup-custom-fields';

export interface SignupFamilyMember {
  child_account_id: string;
  child_name: string;
}

export const ProfileSetupSchema = z.object({
  nextPath: z.string().default('/'),
  parentFields: z.array(SignupFieldEntrySchema).max(100),
  childFieldGroups: z
    .array(
      z.object({
        childAccountId: z.string().uuid(),
        fields: z.array(SignupFieldEntrySchema).max(100),
      }),
    )
    .max(100),
});

export type ProfileSetupData = z.infer<typeof ProfileSetupSchema>;

export function getProfileSetupDestination(next?: string) {
  const safe = getSafeRedirectPath(next, '/');
  const origin = 'https://signup.invalid';
  const destination = new URL(safe, origin);
  if (
    destination.origin !== origin ||
    destination.pathname.replace(/\/+$/, '') === '/auth/profile-setup'
  )
    return '/';
  return `${destination.pathname}${destination.search}${destination.hash}`;
}
